import { WeighingType } from '../weighing-type.enum';
export class EntranceRegistration {
    transportId: number;
    areaGateId: number;
    weighingType: WeighingType;
    weight: number;
    autoWeight: number;
    autoWeightSource: string;
    
}
